import axios from 'axios';
import store from 'store';

const state = {
  cancelSource: undefined,
  claims: {},
  claimTypes: {},
  claimPriorities: {},
  claimsUsers: {},
  claimResolutions: {},
  settlementAmounts: {},
};

const getters = {
  settlementTypeSubco: st => {
    if (st.settlementAmounts.data)
      return st.settlementAmounts.data.filter(settlement => settlement.type.id === 2)[0];
    return '';
  },
  settlementTypeOffice: st => {
    if (st.settlementAmounts.data)
      return st.settlementAmounts.data.filter(settlement => settlement.type.id === 3)[0];
    return '';
  },
  getClaimsFiltered: st => query => {
    if (typeof st.cancelSource !== typeof undefined) {
      st.cancelSource.cancel();
    }
    st.cancelSource = axios.CancelToken.source();
    axios
      .get(`claims/list?${query}`, { cancelToken: st.cancelSource.token })
      .then(res => {
        st.claims = res.data;
        st.cancelSource = undefined;
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          throw err;
        }
      });
  },
};

const mutations = {
  setClaims: (st, payload) => {
    st.claims = payload;
  },
  setClaimTypes: (st, payload) => {
    st.claimTypes = payload;
  },
  setClaimPriorities: (st, payload) => {
    st.claimPriorities = payload;
  },
  setClaimsUsers: (st, payload) => {
    st.claimsUsers = payload;
  },
  setClaimResolutions: (st, payload) => {
    st.claimResolutions = payload;
  },
  setSettlementAmounts: (st, payload) => {
    st.settlementAmounts = payload;
  },
};

const actions = {
  getClaims: ({ commit }) => {
    if (store.get('permissions').indexOf('claims.index') >= 0) {
      axios.get(`claims/list`).then(res => {
        commit('setClaims', res.data);
      });
    }
  },
  getClaimTypes: ({ commit }, companyId) => {
    if (store.get('permissions').indexOf('claims.types.index') >= 0) {
      axios.get(`/values/claim-types?company_id=${companyId}`).then(res => {
        commit('setClaimTypes', res.data);
      });
    }
  },
  getClaimPriorities: ({ commit }) => {
    axios.get(`/values/claim-priorities`).then(res => {
      commit('setClaimPriorities', res.data);
    });
  },
  getClaimsUsers: ({ commit }) => {
    if (store.get('permissions').indexOf('claims.assign') >= 0) {
      axios.get(`/clusters/users/claims`).then(res => {
        commit('setClaimsUsers', res.data);
      });
    }
  },
  getClaimResolutions: ({ commit }) => {
    axios.get(`/values/claim-resolutions`).then(res => {
      commit('setClaimResolutions', res.data);
    });
  },
  getSettlementAmounts: ({ commit }, claimId) => {
    if (store.get('permissions').indexOf('claims.settlement-amounts.show') >= 0) {
      axios.get(`/claims/${claimId}/settlement-amounts`).then(res => {
        commit('setSettlementAmounts', res.data);
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/claims.js